// Terms and Conditions, and Privacy Policy, shown from the sign-up popup
// (LoginRegister.vue) by LegalDocument.vue.
//
// Converted from the text previously pasted inline in LoginRegister.vue, which
// came from a PDF: hard line breaks every ~70 characters, Word's private-use
// bullet (U+F0B7) that phones show as an empty box, and the letterhead repeated
// at every page break. The wording is unchanged, word for word and in order;
// only the repeated page-break letterheads were dropped and the lines rejoined
// into paragraphs.
//
// Block types: meta = letterhead line, h1 = document title, h2 = numbered
// section, h3 = subheading, p = paragraph, li = list item.
export default {
  "terms": {
    "title": "Terms and Conditions",
    "blocks": [
      {
        "t": "meta",
        "text": "Back To Work Connect"
      },
      {
        "t": "meta",
        "text": "Back To Work Connect Directors: G. Oglesby, E. O’Broin, Unit 11 Naas Road"
      },
      {
        "t": "meta",
        "text": "Business Park, www.backtoworkconnect.ie"
      },
      {
        "t": "meta",
        "text": "Muirfield Drive, Inchicore, Dublin 12 info@backtoworkconnect.ie"
      },
      {
        "t": "meta",
        "text": "https://backtoworkconnect.ie/terms-of-use/"
      },
      {
        "t": "h1",
        "text": "BACK TO WORK CONNECT"
      },
      {
        "t": "h1",
        "text": "WEBSITE AND MEMBER ACCOUNT TERMS OF USE"
      },
      {
        "t": "h2",
        "text": "1 WHO WE ARE & HOW TO CONTACT US"
      },
      {
        "t": "p",
        "text": "BACK TO WORK CONNECT LTD is a company limited by guarantee incorporated in Ireland (company number 658117) whose registered office is at Unit 11 Naas Road Business Road, Muirfield Drive, Inchicore, Dublin 12 (BTWC)."
      },
      {
        "t": "p",
        "text": "Company details: BTWC is a social enterprise connecting stay at home parents and career changers to supports, training and job opportunities which can assist them to re-enter the workforce. BTWC operates a website located at: https://backtoworkconnect.ie/ (the Website)."
      },
      {
        "t": "p",
        "text": "Contacting us: To contact us e-mail: info@backtoworkconnect.ie."
      },
      {
        "t": "h2",
        "text": "2 BY USING THE WEBSITE YOU ACCEPT THESE TERMS"
      },
      {
        "t": "p",
        "text": "The following terms and conditions (the Terms) apply to your use of the Website and any related services provided by us in connection with the Website (Services). For the purpose of this document, “use” of the Website and Services includes without limitation:"
      },
      {
        "t": "li",
        "text": "visiting the Website;"
      },
      {
        "t": "li",
        "text": "browsing any information or material which has been made available on the Website;"
      },
      {
        "t": "li",
        "text": "the set-up and use of your Back to Work member account (BTWC Account);"
      },
      {
        "t": "li",
        "text": "registration and use of any Services, including advertising services, on the Website;"
      },
      {
        "t": "li",
        "text": "uploading content, including advertising content, to the website."
      },
      {
        "t": "p",
        "text": "The Website is operated by Back to Work Connect (we / our / us) and these Terms set out the rights and obligations of all users (you / your / User) in relation to your use of the Website."
      },
      {
        "t": "p",
        "text": "By using the Website, you agree to these Terms. Any personal information which is provided by you on the Website will be processed in accordance with our Privacy Policy and our Cookies Policy (as made available on the Website)."
      },
      {
        "t": "p",
        "text": "If you do not agree to these Terms or the contents of our Privacy Policy or the Cookies Policy, you must not use the Website."
      },
      {
        "t": "p",
        "text": "We recommend that you print a copy of these terms for future reference."
      },
      {
        "t": "h2",
        "text": "3 WHO CAN REGISTER FOR A BTWC ACCOUNT"
      },
      {
        "t": "p",
        "text": "There are two types of users that may set up a BTWC Account on the Website:"
      },
      {
        "t": "li",
        "text": "Job/course seeker; and"
      },
      {
        "t": "li",
        "text": "Employer, recruiter, educator, childcare providers, career guidance/personal development coaches or any other organisation who may advertise on the Website from time to time (Advertisers)"
      },
      {
        "t": "h2",
        "text": "4 RESPONSIBILITY FOR INFORMATION UPLOADED"
      },
      {
        "t": "p",
        "text": "You accept sole responsibility for your conduct and any information that you upload, share, exchange or display on the Website. By submitting content which is subsequently made available on the Website, you assume all risks associated with the content. This includes any reliance placed on the quality, accuracy, and completeness of the information provided by other visitors to and users of the Website."
      },
      {
        "t": "p",
        "text": "Purposefully submitting content to the Website which is known to be incorrect or misleading may attract personal liability. You also assume the risk associated with submitting illegal or immoral content which violates any law or regulation."
      },
      {
        "t": "p",
        "text": "Users acknowledge that BTWC is a passive conduit for the distribution of information between Users of the Website (e.g. between job applicants and employers/recruiters). BTWC assumes no responsibility for ensuring that such information is legal, honest, truthful, up to date, accurate, complete or not misleading or that it possesses any other characteristics."
      },
      {
        "t": "h2",
        "text": "5 PROHIBITED USES"
      },
      {
        "t": "p",
        "text": "You must not use the Website or Services for any illegal or unauthorised purpose. You agree to comply with all applicable laws regarding acceptable online conduct. You must not engage in any attempt to modify, adapt, copy, or hack the Website. This includes falsely implying that another service or third party is affiliated with the Website. You must not crawl, scrape, or otherwise cache any content from the Website, including (but not limited to) other user profiles, personal details, photos, graphics, scripts or other content."
      },
      {
        "t": "p",
        "text": "You must not intentionally upload or transmit any viruses, malware, trojans, worms, spyware, adware, or any other malicious, destructive, or unauthorised software to the Website."
      },
      {
        "t": "h2",
        "text": "6 CONTENT"
      },
      {
        "t": "h3",
        "text": "Removal of Content"
      },
      {
        "t": "p",
        "text": "We reserve the right to remove any BWTC Account, or content uploaded to the Website, that we determine to be illegal, offensive, threatening, libelous, defamatory, obscene or otherwise objectionable. We reserve the right to take similar action if we determine that a BTWC Account or content infringes the rights and freedoms of others, or violates these Terms."
      },
      {
        "t": "h3",
        "text": "Intellectual Property"
      },
      {
        "t": "p",
        "text": "You may not sell, copy, reproduce, distribute, modify or otherwise exploit intellectual property owned by us. We are the owner or the licensee of all intellectual property rights in the Website, and in the material published on it(except where specifically identified as third party content). Our intellectual property includes, but is not limited to, graphics, design, branding, computer code and interactive features."
      },
      {
        "t": "p",
        "text": "Nothing in these Terms grants you any right, title, interest or licence in or to our intellectual property rights.  Except for the making of a hard copy print for your own personal use only or the use of others in your organisation (or downloading the material for your own personal use or the use of others in your organisation only provided that you retain all copyright and proprietary notices), the materials on the Website may not be copied, reproduced, transmitted, distributed or displayed, by any means, without the express written consent of BTWC."
      },
      {
        "t": "p",
        "text": "Nothing in these terms grants you the right to publish or use any trademark, service-mark, logo and/or other identifying mark of BTWC in any advertisement, sales promotion, press release and/or publicity or marketing materials without BTWC’s prior written consent."
      },
      {
        "t": "p",
        "text": "Any content you upload to the Website will be considered non-confidential."
      },
      {
        "t": "p",
        "text": "You retain all of your ownership rights in your content uploaded to the Website. When you upload or post content to the Website, you grant BTWC a worldwide, non-exclusive, royalty-free, transferable, sub-licensable licence to use, reproduce, store, distribute and promote your content in connection with the Services and make it available to third parties."
      },
      {
        "t": "p",
        "text": "Any content you upload to the Website must not infringe any third party rights (including intellectual property rights)."
      },
      {
        "t": "h2",
        "text": "7 ADDITIONAL TERMS APPLICABLE TO ADVERTISERS"
      },
      {
        "t": "p",
        "text": "Advertisers agree to comply with the following additional terms."
      },
      {
        "t": "h3",
        "text": "Registration, Responsibility and Security"
      },
      {
        "t": "p",
        "text": "If you are an Advertiser (as defined above) you may set up a BTWC Account in order to advertise on the Website.  You are responsible for any activity or communications that occur through the use of your BTWC Account."
      },
      {
        "t": "p",
        "text": "You are responsible for maintaining the confidentiality of your BTWC Account. If you create a BTWC Account with us, you must treat any information provided as part of our security and authentication procedures (e.g. your password) as confidential. You agree to use a strong password. You must not disclose such information to any person or legal entity that is not otherwise a party to these Terms. You agree to notify BTWC of any unauthorised user of your BTWC Account or passwords."
      },
      {
        "t": "p",
        "text": "You understand and acknowledge that if you cancel your BTWC Account or your BTWC Account is terminated, all your account information, including any Postings (as defined below), will be deleted."
      },
      {
        "t": "h3",
        "text": "Website Postings and Compliance with Law"
      },
      {
        "t": "p",
        "text": "You are solely responsible for your conduct and any information that you upload in your advertisements and postings which are shared, exchanged or displayed on the Website (including but not limited to: the accuracy of the information uploaded, job/training course descriptions, creatives, trademarks, images, URLs) (together, Postings) and all postings or content to which the Postings may redirect Website users to."
      },
      {
        "t": "p",
        "text": "You agree that your Postings, and any interactions with individuals who may respond to your Postings, will comply with all applicable law including but not limited to laws relating to: employment, privacy, data protection, intellectual property and regulatory requirements."
      },
      {
        "t": "p",
        "text": "You agree that your Postings will not:"
      },
      {
        "t": "li",
        "text": "contain the names, logos or trademarks of unaffiliated companies other than those of your organisation except where expressly agreed by us;"
      },
      {
        "t": "li",
        "text": "promote or post information that is inaccurate, false, or misleading;"
      },
      {
        "t": "li",
        "text": "contain any content or links to content that is exploitative of individuals (including in a sexual, violent or other illegal context), or solicits personal information from children;"
      },
      {
        "t": "li",
        "text": "contain a requirement in connection with the Posting which is not an actual or legal requirement for the job or training course;"
      },
      {
        "t": "li",
        "text": "endorse a political party or, political agenda or issue;"
      },
      {
        "t": "li",
        "text": "promote a particular religion;"
      },
      {
        "t": "li",
        "text": "except where permitted by applicable law, request an applicant to provide information relating to their: (i) racial or ethnic origin (ii) political beliefs (iii) philosophical or religious beliefs (iv) membership of a trade union (v) physical or mental health (vi) sexual life (vii) the commission of criminal offences or proceedings or (vii) age;"
      },
      {
        "t": "li",
        "text": "contain anything (e.g. malware, spyware) which would interfere with or obstruct the operation of the Website or Services or which would circumvent any security measure of BTWC."
      },
      {
        "t": "p",
        "text": "If a job or training course advertised in a Posting has been filled, the Posting must be removed as soon as possible."
      },
      {
        "t": "h3",
        "text": "Non-Compliant Postings"
      },
      {
        "t": "p",
        "text": "BTWC reserves the right to:"
      },
      {
        "t": "li",
        "text": "remove any Posting from the Website, which in our reasonable view, does not comply with these Terms or is not in the best interests of BTWC; and/or"
      },
      {
        "t": "li",
        "text": "reject any link contained within a Posting which is not materially functional and/or which BTWC considers to be unsuitable."
      },
      {
        "t": "p",
        "text": "Where a Posting does not comply with these terms, BTWC will first provide you with a description of any non-compliance and will provide you with a reasonable opportunity to remedy any such non-compliance. If you are unable or unwilling to remedy such non-compliance, the Posting shall be deemed cancelled and removed from the Website."
      },
      {
        "t": "p",
        "text": "BTWC reserves the right to cancel and/or withdraw any Posting in the event that this is required by any relevant authority and at BTWC’s sole discretion and without liability to the Advertiser."
      },
      {
        "t": "h3",
        "text": "Website Positioning"
      },
      {
        "t": "p",
        "text": "BTWC does not provide a guaranteed position in connection with any Posting placed on the Website."
      },
      {
        "t": "h3",
        "text": "Payment"
      },
      {
        "t": "p",
        "text": "You agree to meet any and all payment obligations in connection with your use of the Website and the Services and you agree to BTWC storing your payment information for this purpose."
      },
      {
        "t": "p",
        "text": "Unless agreed otherwise, payments which are on a subscription basis are charged monthly in advance until such time as they are cancelled by the Advertiser. BTWC requires a 30 day notice period for cancellation of a subscription. For further information, please contact: info@backtoworkconnect.ie."
      },
      {
        "t": "h2",
        "text": "8 CONFIDENTIALITY"
      },
      {
        "t": "p",
        "text": "All information which is (or which could reasonably be believed to be) confidential and is furnished under these Terms to the receiving party by the disclosing party or any third party at the request of the disclosing party under these Terms shall be and will remain the property of the disclosing party. All copies of such confidential information in written, graphic or tangible form shall be returned to the disclosing party at any time on request of the disclosing party or on termination of these Terms."
      },
      {
        "t": "h2",
        "text": "9 PRIVACY & DATA PROTECTION"
      },
      {
        "t": "p",
        "text": "Any personal data which you provide to us in connection with your use of the Website or Services will be processed in accordance with our Privacy Policy and Cookies Policy which is available via the Website The Website may, from time to time, contain links to and from other websites."
      },
      {
        "t": "p",
        "text": "If you follow a link to any of those websites, please note that those websites have their own privacy and data protection policies and we do not accept any responsibility or liability for those policies. Please check those policies before you submit any personal data to those websites."
      },
      {
        "t": "h2",
        "text": "10 EVENTS OUTSIDE OF BTWC’S CONTROL"
      },
      {
        "t": "p",
        "text": "BTWC will not be liable or responsible for any failure to perform, or delay in performance of, any of its obligations under these Terms that is caused by any act or event beyond BTWC’s reasonable control."
      },
      {
        "t": "h2",
        "text": "11 WARRANTY & INDEMNITY"
      },
      {
        "t": "p",
        "text": "YOU WARRANT THAT:"
      },
      {
        "t": "li",
        "text": "YOU HAVE FULL AUTHORITY TO ENTER INTO THESE TERMS."
      },
      {
        "t": "li",
        "text": "ANY CONTRIBUTION TO THE WEBSITE COMPLIES WITH THE STANDARDS SET OUT IN THIS THESE TERMS."
      },
      {
        "t": "li",
        "text": "WHERE APPLICABLE, THE CONTENTS OF ALL POSTINGS, INFORMATION AND MATERIAL PROVIDED TO THE WEBSITE ARE (I) TRUE AND ACCURATE; (II) DO NOT VIOLATE ANY APPLICABLE LAWS;"
      },
      {
        "t": "p",
        "text": "(III) DO NOT INFRINGE ANY THIRD PARTY RIGHTS (INCLUDING INTELLECTUAL PROPERTY RIGHTS)."
      },
      {
        "t": "p",
        "text": "YOU WILL BE LIABLE TO US AND INDEMNIFY US FOR ANY BREACH OF THESE WARRANTIES. THIS MEANS YOU WILL BE RESPONSIBLE FOR ANY LOSS OR DAMAGE WE SUFFER AS A RESULT OF YOUR BREACH OF WARRANTY."
      },
      {
        "t": "h2",
        "text": "12 LIABILITY & DISCLAIMER"
      },
      {
        "t": "p",
        "text": "TO THE EXTENT PERMITTED BY LAW, BTWC EXCLUDES ALL EXPRESS OR IMPLIED CONDITIONS, WARRANTIES, REPRESENTATIONS, OR OTHER TERMS WHICH MAY APPLY TO THE CONTENT AND SERVICES PROVIDED ON THE WEBSITE."
      },
      {
        "t": "p",
        "text": "BTWC WILL NOT BE HELD LIABLE TO ANY USER FOR LOSS OR DAMAGE ARISING FROM THE USE OF THE WEBSITE OR SERVICES, WHETHER ARISING IN CONTRACT, TORT, STATUTORY DUTY, OR OTHERWISE."
      },
      {
        "t": "p",
        "text": "BTWC DOES NOT GUARANTEE THE ACCURACY OF THE INFORMATION ON THE WEBSITE, AND DISCLAIMS ALL LIABILITY FOR ERRORS OR INACCURACIES IN THE INFORMATION PROVIDED. THIS INCLUDES, BUT IS NOT LIMITED TO  EMPLOYMENT OR OTHER OPPORTUNITIES POSTED BY ADVERTISERS ON THE WEBSITE."
      },
      {
        "t": "p",
        "text": "BTWC RESERVES THE RIGHT TO AMEND INCORRECT OR INCOMPLETE INFORMATION ON THE WEBSITE AT OUR OWN DISCRETION. BTWC DOES NOT ASSUME THE OBLIGATION TO DO SO IN EVERY CIRCUMSTANCE."
      },
      {
        "t": "p",
        "text": "IN CASES WHERE LINKS TO OTHER WEBSITES, SERVICES OR RESOURCES ARE PROVIDED ON THE WEBSITE, BTWC ASSUMES NO RESPONSIBILITY FOR THE CONTENTS OF THESE THIRD PARTY OFFERINGS. SUCH LINKS ARE PROVIDED FOR YOUR INFORMATION ONLY, AND YOUR USE OR RELIANCE ON THE THIRD PARTY INFORMATION IS AT YOUR OWN RISK. BTWC HAS NO CONTROL OVER THE CONTENTS OF THOSE SITES OR RESOURCES."
      },
      {
        "t": "p",
        "text": "ANY SERVICES PROVIDED BY A THIRD PARTY IN CONNECTION WITH THE WEBSITE MAY BE SUBJECT TO ADDITIONAL TERMS OF SERVICE AND PRIVACY POLICIES. IT IS YOUR RESPONSIBILITY TO REVIEW AND FAMILIARISE YOURSELF WITH THESE TERMS AND POLICIES."
      },
      {
        "t": "h2",
        "text": "13 WEBSITE AVAILABILITY"
      },
      {
        "t": "p",
        "text": "The Website is provided on an “as available” basis. Although BTWC will make every reasonable effort to ensure continued uninterrupted access, there may be occasions where such access will be unavailable. BTWC does not guarantee that the Website will be secure or free from bugs or viruses."
      },
      {
        "t": "h2",
        "text": "14 VARIATIONS TO THE WEBSITE & TERMS OF USE"
      },
      {
        "t": "p",
        "text": "BTWC reserves the right to modify the Website and Services at any time without the requirement to provide notice."
      },
      {
        "t": "p",
        "text": "BTWC also reserves the right to modify these Terms at any time. If we make changes to these Terms, the Privacy Policy or Cookies Policy, we will notify you by providing appropriate notice on the Website. The date on which these Terms was last updated will also be indicated on this webpage. Once you have received notification of such changes, your continued use of the Website and Services will indicate your awareness and acceptance of those changes."
      },
      {
        "t": "p",
        "text": "If you do not agree to be bound by any changes to these Terms, you will not be able to continue to use the Website and Services."
      },
      {
        "t": "h2",
        "text": "15 GOVERNING LAW & JURISDICTION"
      },
      {
        "t": "p",
        "text": "The Irish courts will have exclusive jurisdiction over any claim arising from, or related to, these Terms, although we retain the right to bring proceedings against you for breach of these Terms in your country of residence or any other relevant country. These Terms and any dispute or claim arising out of them shall be governed by and construed in accordance with the law of Ireland."
      },
      {
        "t": "h2",
        "text": "16 TERMINATION"
      },
      {
        "t": "p",
        "text": "BTWC reserves the right to restrict, remove, or prevent access to the Website and Services or terminate your BTWC Account if you fail to comply with these Terms. Such actions are at our sole discretion."
      },
      {
        "t": "p",
        "text": "Further cancellation terms apply to Advertisers with subscriptions as outlined above under Clause 7 – ‘Additional Terms Applicable to Advertisers’."
      },
      {
        "t": "p",
        "text": "If any of these Terms are determined by any competent authority to be invalid, unlawful or unenforceable to any extent, such term, condition or provision will to the extent be severed from the remaining terms, conditions and provisions which will continue to be valid to the fullest extent permitted by law."
      },
      {
        "t": "h2",
        "text": "17 COMPLAINTS"
      },
      {
        "t": "p",
        "text": "Should you have any complaints regarding the Website, Services, or these Terms, please direct these to the following email address: info@backtoworkconnect.ie."
      },
      {
        "t": "p",
        "text": "If you have any concerns, queries, or complaints regarding your data privacy, please refer to the relevant section in our Privacy Policy."
      },
      {
        "t": "p",
        "text": "Last updated: 22 July 2020"
      }
    ]
  },
  "privacy": {
    "title": "Privacy Policy",
    "blocks": [
      {
        "t": "meta",
        "text": "Back To Work Connect"
      },
      {
        "t": "meta",
        "text": "Back To Work Connect Directors: G. Oglesby, E. O’Broin, Unit 11 Naas Road"
      },
      {
        "t": "meta",
        "text": "Business Park, www.backtoworkconnect.ie"
      },
      {
        "t": "meta",
        "text": "Muirfield Drive, Inchicore, Dublin 12 info@backtoworkconnect.ie"
      },
      {
        "t": "meta",
        "text": "https://backtoworkconnect.ie/privacy-notice-gdpr-policy/"
      },
      {
        "t": "h1",
        "text": "PRIVACY NOTICE"
      },
      {
        "t": "p",
        "text": "Back to Work Connect (“we”, “us” or “our”) is committed to protecting and respecting your privacy. This Privacy Notice tells you about your privacy rights and sets out how we, as a data controller, collect and process personal data relating to you."
      },
      {
        "t": "h3",
        "text": "About Us"
      },
      {
        "t": "p",
        "text": "Back to Work Connect, Unit 11 Naas Road Business Road, Muirfield Drive, Inchicore, Dublin 12, is a registered business name (no.658117) .  You can contact us by email at info@backtoworkconnect.ie Back To Work Connect is an employment and education career hub designed to get people back to work."
      },
      {
        "t": "p",
        "text": "The main objects for the Back To Work Connect is to connect stay at home parents with the support, training, upskilling (whether online or in person) and relevant job or educational opportunities they need to re-enter the workforce (Returners) in a meaningful and financially viable manner."
      },
      {
        "t": "h3",
        "text": "Information we may collect from you"
      },
      {
        "t": "p",
        "text": "“Personal data” means any information about an individual from which that person can be identified. We collect personal data on our website www.backtoworkconnect.ie through registration forms, contact us forms and register as a client form. We also collect personal data if you communicate with us by subscribing to a newsletter or email list, providing feedback, or by completing a survey”."
      },
      {
        "t": "p",
        "text": "The type of information we collect from Users includes:"
      },
      {
        "t": "li",
        "text": "Administrative information, such as your email address, your name."
      },
      {
        "t": "p",
        "text": "The type of information we collect from Clients includes"
      },
      {
        "t": "li",
        "text": "Administrative information, such as your name, address, email, age, economic status, age Note: If you provide us with personal data relating to other people you must first: (a) inform the person about the content of this Privacy Notice; and (b) obtain any legally required consent from that person to the sharing of their personal data in this manner."
      },
      {
        "t": "p",
        "text": "In addition to the information provided to us, we may collect certain information when you visit our website, as explained below under ‘Cookies’."
      },
      {
        "t": "p",
        "text": "In providing our services, we may also receive personal data indirectly."
      },
      {
        "t": "p",
        "text": "Categories of such personal data include names, addresses, contact information and other information that is relevant to the provision of our services."
      },
      {
        "t": "h3",
        "text": "How we use the personal data we collect"
      },
      {
        "t": "p",
        "text": "We will only use your personal data for the purposes and legal bases set out in the table below."
      },
      {
        "t": "p",
        "text": "Purpose(s) for Processing             Legal Basis To provide our online services, including:"
      },
      {
        "t": "li",
        "text": "Providing our website to you, allowing you to register as a user and browse employment advertisements The processing is necessary for the performance of our contract with you in relation to our website services."
      },
      {
        "t": "h3",
        "text": "Other processing purposes"
      },
      {
        "t": "p",
        "text": "If we intend to process your personal data for any other purpose, we will inform you of this purpose and the legal basis for the processing."
      },
      {
        "t": "h3",
        "text": "Data Retention"
      },
      {
        "t": "p",
        "text": "Data will be stored for as long as required to satisfy the purpose for which the data was collected and used unless a longer period is necessary for our legal, accounting or reporting obligations or for the exercise or defence of legal claims."
      },
      {
        "t": "h3",
        "text": "Disclosure of your information"
      },
      {
        "t": "p",
        "text": "Personal data may be disclosed to:"
      },
      {
        "t": "li",
        "text": "Service providers who assist us in connection with the ways we may use personal information."
      },
      {
        "t": "li",
        "text": "Regulators and government authorities in connection with our compliance procedures and obligations."
      },
      {
        "t": "li",
        "text": "Other third parties on occasions where we are authorised or required by law to do so."
      },
      {
        "t": "p",
        "text": "Security and where we store your personal data We cannot guarantee the complete security of our database, nor can we guarantee that information you supply will not be intercepted while being transmitted to us over the Internet. Although we will do our best to protect your personal data, we cannot guarantee the security of your personal data transmitted through our website. Any transmission of personal data is at your own risk."
      },
      {
        "t": "p",
        "text": "We have put in place appropriate security measures to prevent your personal information from being accidentally lost, used or accessed in an unauthorised way, altered or disclosed. We securely store your personal data in a centralised database, with controlled access to such database."
      },
      {
        "t": "p",
        "text": "Access to personal data in both electronic and paper form is restricted to our employees who have a legitimate and justifiable reason to view such data."
      },
      {
        "t": "p",
        "text": "Any hard copies of your personal data are kept in Ireland by us.  Electronic copies of your personal data are stored online with our service providers."
      },
      {
        "t": "p",
        "text": "These third parties will only process your personal information on our instructions and where they have agreed to treat the information confidentially and to keep it secure."
      },
      {
        "t": "p",
        "text": "In the event of a suspected data security breach, we will follow required procedure and will notify you and the Irish Data Protection Commission of a suspected breach where we are legally required to do so."
      },
      {
        "t": "p",
        "text": "Transfers of personal data outside the European Economic Area (EEA) The personal data that we collect from you may be transferred to, and stored at, a destination outside the EEA (including to service providers who may be located, or store data, outside the EEA) for the purposes described above."
      },
      {
        "t": "p",
        "text": "We will ensure suitable safeguards are in place to protect the privacy and integrity of your personal data in such circumstances. You can obtain information pertaining to these safeguards by contacting us."
      },
      {
        "t": "h3",
        "text": "Links to other websites"
      },
      {
        "t": "p",
        "text": "Our website may, from time to time, contain links to and from other websites."
      },
      {
        "t": "p",
        "text": "If you follow a link to any of those websites, please note that those websites have their own privacy policies and we do not accept any responsibility or liability for those policies. Please check those policies before you submit any personal data to those websites."
      },
      {
        "t": "h3",
        "text": "Your rights"
      },
      {
        "t": "p",
        "text": "You have various rights under the GDPR, including the right to access, rectification, and erasure. In each case, these rights are subject to restrictions as laid down by law."
      },
      {
        "t": "p",
        "text": "The following is a summary of your rights:"
      },
      {
        "t": "li",
        "text": "The right of access enables you to receive a copy of your personal data;"
      },
      {
        "t": "li",
        "text": "The right to rectification enables you to correct any inaccurate or incomplete personal data we hold about you;"
      },
      {
        "t": "li",
        "text": "The right to erasure enables you to request that we delete your personal data in certain circumstances;"
      },
      {
        "t": "li",
        "text": "The right to restrict processing enables you to ask us to stop processing your personal data in certain circumstances;"
      },
      {
        "t": "li",
        "text": "The right to object enables you to object to us processing your personal data on the basis of our legitimate interests (or those of a third party);"
      },
      {
        "t": "li",
        "text": "The right to data portability enables you to request us to transmit personal data that you have provided to us, to a third party. This will be done without hindrance, and a copy of the personal data can also be provided to you when it is technically feasible to do so."
      },
      {
        "t": "p",
        "text": "You have the right to lodge a complaint with the Irish Data Protection Commission, if you consider that our processing of your personal data infringes the GDPR."
      },
      {
        "t": "p",
        "text": "If you wish to exercise any of these rights, please contact us (see ‘contact us’ below). We will respond to your request within one month. That period may be extended by two further months where necessary, taking into account the complexity and number of requests. We will inform you of any such extension within one month of receipt of your request. We may request proof of identification to verify your request. We have the right to refuse your request where there is a basis to do so in law, or if it is manifestly unfounded or excessive, or to the extent necessary for important objectives of public interest."
      },
      {
        "t": "h3",
        "text": "Links to other websites"
      },
      {
        "t": "p",
        "text": "This Privacy Notice applies only to our website. The website may contain links to other web sites not operated or controlled by us (“Third Party Sites”). The policies and procedures we describe here do not apply to Third Party Sites and we are not responsible for Third Party Sites’ content, any use of Third Party Sites, or the privacy practices of Third Party Sites. Any links from this website do not imply that we endorse or have reviewed Third Party Sites. We suggest contacting those sites directly for information on their privacy policies."
      },
      {
        "t": "h3",
        "text": "Changes to this Privacy Notice"
      },
      {
        "t": "p",
        "text": "We reserve the right to change this Privacy Notice from time to time at our sole discretion. If we make any changes, we will post those changes here and update the “last updated” date at the top of this Privacy Notice.  However, if we make material changes to this Privacy Notice, we will notify you by means of a prominent notice on the website prior to the change becoming effective."
      },
      {
        "t": "p",
        "text": "Please review this Privacy Notice periodically for updates."
      },
      {
        "t": "h3",
        "text": "Contact Us"
      },
      {
        "t": "p",
        "text": "Questions, comments, requests and complaints regarding this Privacy Notice and the personal data we hold are welcome and should be addressed to info@backtoworkconnect.ie .  All requests will be dealt with promptly and efficiently."
      }
    ]
  }
}
